import * as React from 'react'

import { LoginForm, LoginFormSSO } from 'main/components/common/AuthModal'
import { CredentialsFields } from 'main/gql/credentials'
import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import { Text } from 'main/ui'
import { TextContainer } from '../GatheringRegistrationModal.styles'

interface IProps {
  onRequestSignUp: () => void
  onComplete: (credentials: CredentialsFields) => void
}

export default function Login(props: IProps) {
  const { onRequestSignUp, onComplete } = props

  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()

  if (isSSO) {
    return (
      <div>
        <LoginFormSSO />
      </div>
    )
  } else {
    return (
      <div>
        <TextContainer>
          <Text>Log in to RSVP</Text>
        </TextContainer>

        <LoginForm cta="Next" onComplete={onComplete} onRequestSignUp={onRequestSignUp} />
      </div>
    )
  }
}
